import type { IAppSettingsStorageService } from "@/application/ports/services/IAppSettingsStorageService";
import type { IStorageService } from "@/application/ports/services";
import type { AppSettings } from "@/domain/common";
import { STORAGE_KEYS } from "./constants";

export class AppSettingsStorageService implements IAppSettingsStorageService {
  constructor(private storageService: IStorageService) {}

  getSettings(): AppSettings | null {
    return this.storageService.get<AppSettings>(STORAGE_KEYS.APP_SETTINGS);
  }

  saveSettings(settings: AppSettings): void {
    this.storageService.set(STORAGE_KEYS.APP_SETTINGS, settings);
  }
}
